import {V3Record} from 'data/helpers/V3Record.js'

export const Club = V3Record('club', {
  name: null,
  userId: null,
  appDetails: null
})
